import {Image, UnstyledButton} from "@mantine/core";
import React from "react";
import ReadMore from "@/app/(index)/read-more";
import {IArticleListForm, TFile} from "@/form/article";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";


interface IProps {
    item: IArticleListForm
}
const ArticleCard: React.FC<IProps> = ({ item }) => {
    const { fontSize, lang } = useGlobalStateStore();
    return (
        <UnstyledButton component="a" target={item.category == "LINK" ? "_blank" : "_self"}
                        href={item.category == "LINK" ? ( lang == "tw" ? item.linkUrl!! : item.linkUrlE!! ) : `/news/detail/${item.artId}`}>
            <div className="flex flex-col gap-[10px] h-full group justify-start">
                <div style={{ backgroundImage: `url(${process.env.NEXT_PUBLIC_API_HOST}/image/${item.fromOld ? 'original' : 'crop'}/${item.coverArhId?.arhId})` }}
                     className="h-[281px] w-full bg-cover bg-no-repeat bg-center border border-[#abd0cb] rounded-[20px]">
                </div>
                <div className="text-[#b6b6b6] text-[17px] font-bold">{item.publishDate}</div>
                <div
                    className="text-[#158a83] text-[22px] font-bold group-hover:text-black flex-1 line-clamp-2">
                    {lang == "tw" ? item.titleC : item.titleE}
                </div>
                <div className={"mt-[15px]"}>
                    <ReadMore/>
                </div>
            </div>
        </UnstyledButton>
    );
}

export default ArticleCard;
